import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Radium, { Style } from 'radium';

import * as defaultStyles from '../../../styles';
import { request } from '../../../containers/actions';
import { host, host_v2 } from '../../../utilities/requests';
import QuestionDifficulty  from '../../../../src/utilities/persian'
import { isSpecialized } from '../../../utilities/material';

//Radium(TeacherReport)
export default class TeacherReport extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    constructor(props,context) {
        super(props,context);
        this.state = {
            classId: '_' + window.uuidv4(),
        };
    }

    componentDidMount() {
        if (this.props.school && this.props.examination && this.props.examination.id)
            this.fetchReport.bind(this)();

        if (this.props.user?.type?.at(0) === 'teacher')
            this.fetchReportTeacher();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.school !== this.props.school ||
            (prevProps.examination && prevProps.examination.id) !==
            (this.props.examination && this.props.examination.id)) {
            this.fetchReport.bind(this)();
        }
        if (!prevState.print && this.state.print) {
            window.scrollTo(0, 0);
            window.print();
            this.setState({ print: false });
        }


    }

    async fetchReportTeacher() {
        this.setState({ data: null });
        
        var token = this.context.store.getState().get('application').get('token');
        var auth = token.get('accessToken');
        let body = {
            getRealTeacherData: 'true'
        };

        const response = await fetch(host + `/api/examination/${this.props.examination.id}/report/school/teacher/`, {
            headers: {
                Authorization: 'Bearer ' + auth,
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(body)
        });

        const data = await response.json();
        const classId = Object.keys(data?.classes)?.at(0);
        const teacherMaterials = data.teacher_class_material.filter(x=>{return Number(Object.keys(x.clazz)) == classId});
        if(teacherMaterials.length == 0)
        {
            alert('کارنامه ای برای درس و کلاس شما ثبت نشده است.');
            return;
        }
        const materialId = Object.keys(teacherMaterials[0].material)?.at(0);
        if (data.errorId)
            return;

        this.setState({
            data: data,
            class: !!data[classId]?Number(classId):'school',
            className: window.gettext('Class'),
            material: materialId?Number(materialId): 'all',
            materialName: window.gettext('All'),
            teacher_class_material:data.teacher_class_material,
        });
        // if(this.props.examination.examination_type?.id !== 1 && this.props.examination.examination_type?.id !== 2){
        //     this.props.examination.participants = this.props.examination.participants_count;
        // }
    }

    async fetchReport() {
        const school = this.props.school;
        if (!school || !this.props.examination || !this.props.examination.id) {
            this.setState({ data: undefined });
            return;
        }
        this.setState({ data: null });
        let body = { school };
        if (this.context.user?.type?.at(0) === 'teacher') {
            body = {
                getRealTeacherData: true
            }
        }
        const response = await this.context.store.dispatch(request({
            path: `/examination/${this.props.examination.id}/report/school/teacher/`,
            body
        }));
        this.setState({
            data: response,
            class: 'school',
            className: window.gettext('School'),
            material: 'all',
            materialName: window.gettext('All'),
        });
        // if(this.props.examination.examination_type?.id !== 1 && this.props.examination.examination_type?.id !== 2){
        //     this.props.examination.participants = this.props.examination.participants_count;
        // }
    }

    SetStateOnClickClass(id,) {
        this.setState({class: Number.parseInt(id), className: window.gettext('Class')});
        if(this.props.user?.type?.at(0) === 'teacher'){
            const teacherMaterials = this.state.data.teacher_class_material.filter(x=>{return Number(Object.keys(x.clazz)) == id});
            const materialId = Object.keys(teacherMaterials[0].material)?.at(0);
            this.setState({
                material: materialId?Number(materialId): 'all',
            });
        }
    }

    render() {
        if (!this.state || !this.state.data)
            return null;
        if (_.keys(this.state.data.global).length === 0)
            return <div>{window.gettext('Please check again later!')}</div>;
        return <div>
            <div style={{ marginBottom: '.5em', marginTop: '.75em' }}>
                <button
                    key='print'
                    style={{ ...defaultStyles.defaultButton, backgroundColor: defaultStyles.fourthColor, float: 'left' }}
                    onClick={() => this.setState({ print: true })}>
                    {window.gettext('Print')}
                </button>&nbsp;
                {window.gettext('Choose class') + ' : '}
                {_.map({ ...this.state.data.classes }, (name, id) => <button
                    key={'class-' + id}
                    style={{
                        ...(this.state.class === Number.parseInt(id)
                            ? defaultStyles.activeButton
                            : defaultStyles.button),
                        marginLeft: '.5em',
                    }}
                    onClick={() => this.SetStateOnClickClass(id)}>
                    {(name || window.gettext('No Name')).persian()}
                    
                </button>)}
                {this.props.user?.type?.at(0) !== 'teacher'? <button
                    key='school'
                    style={this.state.class === 'school' ? defaultStyles.activeButton : defaultStyles.button}
                    onClick={() => this.setState({ class: 'school', className: window.gettext('School') })}>
                    {window.gettext('All Classes')}
                </button>:null
            }
                <div style={{ height: '2em', clear: 'right' }}></div>
               {this.props.user?.type?.at(0) !== 'teacher'? <button
                    key='all'
                    style={
                        this.state.material === 'all'
                            ? defaultStyles.activeTabButton
                            : defaultStyles.tabButton
                    }
                    onClick={() => this.setState({ material: 'all', materialName: window.gettext('All') })}>
                    {window.gettext('All')}
                </button>:null}
                {_.map({ ...this.props.user?.type?.at(0) !== 'teacher' ? this.state.data.materials : (this.state.data.teacher_class_material.filter(x=>{return Number(Object.keys(x.clazz)) == this.state.class})[0]).material}, (name, id) => 
                 <button
                    key={'material-' + id}
                    style={{
                        ...(this.state.material === Number.parseInt(id)
                            ? defaultStyles.activeTabButton
                            : defaultStyles.tabButton),
                    }}
                    onClick={() => this.setState({ material: Number.parseInt(id), materialName: name })}>
                    {name.persian()}
                </button>)}
            </div>
            {this.state.data
                ? <span>
                    <div
                        style={{
                            ...defaultStyles.box,
                            width: '100%',
                            overflow: 'hidden',
                        }}>
                        <div style={{ float: 'right', width: '25%' }}>
                            {window.gettext('Examination')}: {this.props.examination.title}
                        </div>
                        <div style={{ float: 'right', width: '25%' }}>
                            {window.gettext('School Name')}: {this.state.data.school_display}
                        </div>
                        <div style={{ float: 'right', width: '25%' }}>
                            {window.gettext('City')}: {this.state.data.city_display}
                        </div>
                        <div style={{ float: 'right', width: '25%' }}>
                            {window.gettext('Grade')}: {this.state.data.grade_display}
                        </div>
                        <div style={{ float: 'right', width: '25%' }}>
                            {window.gettext('Holding Date')}: {this.props.examination.date ? this.props.examination.date.toJalali().persian() : ''}
                        </div>
                        <div style={{ float: 'right', width: '25%' }}>
                            {window.gettext('Analyze Date')}: {this.props.examination.analyze_date
                                ? this.props.examination.analyze_date.toJalali().persian()
                                : ''
                            }
                        </div>
                        <div style={{ float: 'right', width: '25%' }}>
                            {window.gettext('Centers Participated')}: {(this.state.data.centers || '').persian()}
                        </div>
                        <div style={{ float: 'right', width: '25%' }}>
                            {window.gettext('Participants')}: {(this.state.data.participants || '').persian()}
                        </div>
                        <div style={{ clear: 'right', textAlign: 'center', fontWeight: '700' }}>
                            {/* {window.interpolate( //TODO
                                window.gettext('Ranks are based on %(analyzeModel)s!'),
                                {analyzeModel: this.props.examination.analyze_model === 1 ? window.gettext('Taraz') : window.gettext('Score')},
                                true,
                            )} */}
                        </div>
                    </div>

                </span>
                : null
            }
            {this.state.print
                ? <span class='media-print-display'>
                    <span style={{marginTop:'-5rem'}}>
                    <div
                        style={{
                            position: 'absolute',
                            top: '21mm',
                            right: '61mm',
                            width: '52mm',
                            fontSize: '1.40em',
                        }}>
                        <div style={{ textAlign: 'center' }}>
                            <b>{window.gettext('Teacher Report')}</b>
                        </div>
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '9mm',
                            right: '127mm',
                            width: '63.2mm',
                        }}>
                        <div style={{ overflow: 'hidden', height: '2.3em' }}>
                            <b>{window.gettext('School Name')}:</b>&nbsp;
                            {this.state.data.school_display} - {this.state.data.city_display}
                        </div>
                        <div style={{ overflow: 'hidden', height: '2.3em' }}>
                            <b>{window.gettext('Examination')} - {window.gettext('Grade')}:</b>&nbsp;
                            {this.props.examination.title} - {this.state.data.grade_display}
                        </div>
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '9mm',
                            right: '202mm',
                            width: '42mm',
                        }}>
                        <div style={{ overflow: 'hidden', height: '2.3em' }}>
                            <b>{window.gettext('Holding Date')}:</b> {this.props.examination.date
                                ? this.props.examination.date.toJalali().persian()
                                : ''
                            }
                        </div>
                        <div style={{ overflow: 'hidden', height: '2.3em' }}>
                            <b>{window.gettext('Teacher')}:</b> -
                        </div>
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '9mm',
                            right: '254mm',
                            width: '34mm',
                        }}>
                        <div style={{ overflow: 'hidden', height: '2.3em' }}>
                            <b>{window.gettext('Class')}:</b> {this.state.className}
                        </div>
                        <div style={{ overflow: 'hidden', height: '2.3em' }}>
                            <b>{window.gettext('Material')}:</b> {this.state.materialName}
                        </div>
                    </div>
                    </span>
                    {/* <div
                            style={{
                                position: 'absolute',
                                top: '185mm',
                                right: '16mm',
                                width: '71mm',
                            }}>
                            <div style={{overflow: 'hidden', height: '2.3em'}}>
                                <b>{window.gettext('Analyze Date')}:</b> {(this.props.examination.analyze_date || '').persian()}
                            </div>
                        </div>
                        <div
                            style={{
                                position: 'absolute',
                                top: '185mm',
                                right: '120mm',
                                fontSize: '1.3em',
                                fontFamily: 'Arial',
                            }}>
                            <b>www.mhelli.com</b>
                        </div> */}
                    <Style
                        rules={{
                            '@page': {
                                size: 'A4 Landscape',
                                marginTop: '2rem',
                                marginLeft: '0',
                                marginRight: '0',
                                marginBottom: '17mm',
                            },
                            mediaQueries: {
                                print: {
                                    '*': {
                                        backgroundColor: 'unset !important',
                                    },
                                    body: {
                                        visibility: 'hidden',
                                    },
                                    '.page': {
                                        minHeight: 'unset',
                                    },
                                },
                            },
                        }}>
                    </Style>
                </span>
                : null
            }

            <div
                style={this.state.print ? undefined : {
                    ...defaultStyles.box,
                    marginTop: '1em'
                }}>
                <div style={{ display: this.state.print ? undefined : 'inline-block' }} className={this.state.classId}
                    class='media-print-display school-teacher-media-print' >
                    <table style={{...defaultStyles.table, marginTop:this.state.print?'7rem':'0' }}>
                        <thead style={{ backgroundColor: '#cccccc' }}>
                            <tr style={{ '@media print': { height: '34mm', border: 'none' } }} />
                            <tr>
                                <th rowSpan='2' style={{ ...defaultStyles.th, width: '3em' }}>
                                    {window.gettext('Index')}
                                </th>
                                <th rowSpan='2' style={{ ...defaultStyles.th, width: '3em' }}>
                                    {window.gettext('Correct Option')}
                                </th>
                                {_.map(Array(5), (__, option) => <th
                                    colSpan='2'
                                    key={option}
                                    style={{ ...defaultStyles.th, width: '10em' }}>
                                    {option == 0
                                        ? window.gettext('Empty Answer')
                                        : window.interpolate(
                                            window.gettext('Answered to Option %(option)s'),
                                            { option: option.persian() },
                                            true,
                                        )
                                    }
                                </th>)}
                                {
                                    console.log('this.context.user',this.context.user)
                                }
                                {
                                    (this.context.user.type[0] === 'admin' || (this.context.user.type[0] === 'client' && this.context.user.hasPerm('client.special'))) ?
                                    <th rowSpan='2' style={{ ...defaultStyles.th, width: '6em' }}>
                                        {window.gettext('Difficulty Level')}
                                    </th>
                                    : null
                                }

                            </tr>
                            <tr>
                                {_.map(Array(5), (__, option) => [
                                    <th key={option + '-local'} style={{ ...defaultStyles.th, width: '5em' }}>
                                        {this.state.className}
                                    </th>,
                                    <th key={option + '-global'} style={{ ...defaultStyles.th, width: '5em' }}>
                                        {window.gettext('Global')}
                                    </th>,
                                ])}
                            </tr>
                        </thead>
                        <tbody>
                            {_.map(this.state.data.global, (row, index) => this.state.material === 'all' ||
                                _.includes(this.state.data.questions[index], this.state.material)
                                ? <tr style={defaultStyles.th} key={index}>
                                    <td
                                        key={index}
                                        style={{ ...defaultStyles.td, width: '3em' }}>
                                        {(Number.parseInt(index) + 1).persian()}
                                    </td>
                                    <td
                                        key={'correct-' + index}
                                        style={{ ...defaultStyles.td, width: '3em' }}>
                                        {this.state.data.key[index]
                                            ? (Math.log2(this.state.data.key[index] * 2 || 1)).persian()
                                            : window.gettext('This question is removed.')}
                                    </td>
                                    {_.map(Array(5), (__, option) => {
                                        const isAnswer = this.state.data.key[index] === 0 && option === 0 ||
                                            this.state.data.key[index] > 0 && this.state.data.key[index] & (1 << (option - 1));
                                        const localValue = (this.state.data[this.state.class][index] || {})[option.toString()] || 0;
                                        const globalValue = (this.state.data.global[index] || {})[option.toString()] || 0;
                                        return [
                                            <td
                                                key={index + '-' + option + '-local'}
                                                style={{
                                                    ...defaultStyles.td, width: '5em',
                                                    padding: '0',
                                                    textAlign: 'center',
                                                    fontWeight: isAnswer ? 800 : undefined,
                                                    color: isAnswer ? localValue < globalValue ? 'red' : 'green' : undefined,
                                                    backgroundColor: isAnswer ? localValue < globalValue
                                                        ? 'rgba(255, 0, 0, .2)'
                                                        : 'rgba(0, 255, 0, .2)' : undefined,
                                                }}>
                                                <div
                                                    style={{
                                                        padding: defaultStyles.td.padding,
                                                        '@media print': {
                                                            backgroundColor: isAnswer ? localValue < globalValue
                                                                ? '#dadada'
                                                                : '#a7a7a7' : undefined,
                                                            color: 'black',
                                                        },
                                                    }}>
                                                    {localValue.toPercent().persian(true)}
                                                </div>
                                            </td>,
                                            <td
                                                key={index + '-' + option + '-global'}
                                                style={{
                                                    ...defaultStyles.td, width: '5em',
                                                    padding: '0',
                                                    textAlign: 'center',
                                                    fontWeight: isAnswer ? 800 : undefined,
                                                    color: isAnswer ? localValue < globalValue ? 'red' : 'green' : undefined,
                                                    backgroundColor: isAnswer ? localValue < globalValue
                                                        ? 'rgba(255, 0, 0, .2)'
                                                        : 'rgba(0, 255, 0, .2)' : undefined,
                                                }}>
                                                <div
                                                    style={{
                                                        padding: defaultStyles.td.padding,
                                                        '@media print': {
                                                            backgroundColor: isAnswer ? localValue < globalValue
                                                                ? '#dadada'
                                                                : '#a7a7a7' : undefined,
                                                            color: 'black',
                                                        },
                                                    }}>
                                                    {globalValue.toPercent().persian(true)}
                                                </div>
                                            </td>,
                                        ];
                                    })}
                                    {
                                        (this.context.user.type[0] === 'admin' || (this.context.user.type[0] === 'client' && this.context.user.hasPerm('client.special'))) ?
                                        <td
                                        key={'Difficulty-' + index}
                                        style={{ ...defaultStyles.td, width: '3em' }}>
                                        {this.state.data.key[index]
                                            ? 
                                            Math.floor(((this.state.data.global[index] || {})[Math.log2(this.state.data.key[index] * 2 || 1)] * 100)).QuestionDifficulty(
                                                isSpecialized(this.state.data.materials[this.state.data.questions[index]])
                                            )
                                            : "-"}
                                        </td>
                                        : null
                                    }
                                </tr>
                                : null,
                            )}
                        </tbody>
                        <tfoot>
                            {/* <tr style={{height: '26mm'}}></tr> */}
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>;
    }
}
